/**
 * Hausmarken-Streifen (siehe snippets/zr-hausmarken.liquid).
 *
 * Holt die eigenen Marken der aktuellen Kollektion ueber den Hersteller-Filter
 * nach und stellt sie ueber das Raster. Sortiert absteigend nach dem
 * Prioritaets-Metafeld; ohne gepflegte Prioritaet bleibt Shopifys Reihenfolge.
 *
 * Der Streifen ist im Markup `hidden` und wird erst sichtbar, wenn wirklich
 * genug Treffer da sind. Faellt der Abruf aus, bleibt die Seite exakt so, wie
 * sie ohne den Streifen waere — das Raster darunter ist der eigentliche Inhalt.
 */
(function () {
  'use strict';

  var HERSTELLER = ['RID', 'Dirt']; // Werte des Metafelds custom.hersteller
  var MIN_TREFFER = 5;              // darunter lohnt die Reihe nicht
  var MAX_KARTEN = 8;               // zwei Reihen à 4 auf dem Desktop

  /**
   * Shopify liefert Storefront-Filter nur bis 5.000 Produkte je Kollektion.
   * Darueber wird der Filter STILL ignoriert und die Antwort enthaelt die
   * ganze Kollektion (auf /collections/felgen-5x112 real nachgewiesen: auch
   * ein Unsinnswert liefert alle 9.055 Produkte). Ohne diese Pruefung stuende
   * dort irgendwann der halbe Katalog im Hausmarken-Streifen.
   *
   * Die Schwelle muss die beiden Faelle klar trennen, nicht nur "viel" von
   * "wenig": greift der Filter nicht, kommen ~100 % der Kollektion zurueck.
   * Legitim sind dagegen durchaus hohe Anteile — auf 6x114,3 sind 54 % der
   * Felgen Hausmarken. Eine zu enge Schwelle wuerde ausgerechnet die besten
   * Lochkreise stillegen.
   */
  var MAX_ANTEIL = 0.8;

  /** Produkt-Handle aus einem Link, ohne Query und Slash am Ende. */
  function handleAus(a) {
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var teil = href.split('?')[0].replace(/\/$/, '').split('/products/')[1];
    return teil || null;
  }

  function init(el) {
    var handle = el.getAttribute('data-collection');
    var gesamt = parseInt(el.getAttribute('data-collection-size'), 10) || 0;
    if (!handle) return;

    var url =
      '/collections/' + encodeURIComponent(handle) + '?view=hausmarken&' +
      HERSTELLER.map(function (h) {
        return 'filter.p.m.custom.hersteller=' + encodeURIComponent(h);
      }).join('&');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('[data-hausmarken-total]');
        if (!wrap) return;

        var treffer = parseInt(wrap.getAttribute('data-hausmarken-total'), 10) || 0;
        if (treffer < MIN_TREFFER) return;
        if (gesamt > 0 && treffer / gesamt > MAX_ANTEIL) return; // Filter hat nicht gegriffen

        var items = Array.prototype.slice.call(wrap.querySelectorAll('.zr-hm__item'));
        if (items.length < MIN_TREFFER) return;

        // Was im Raster darunter ohnehin schon steht, gehoert nicht in den
        // Streifen — sonst sieht der Kunde dieselbe Felge zweimal auf einem
        // Bildschirm. Real aufgetreten auf 6x139,7: die erste Karte des
        // Streifens war zugleich die erste im Raster.
        //
        // Kein Zufall, sondern strukturell: Streifen und Raster ziehen aus
        // derselben Kollektion in derselben Shopify-Reihenfolge, der Streifen
        // nur zusaetzlich nach Hersteller gefiltert. Die Bestseller stehen
        // damit zwangslaeufig in beiden.
        //
        // Ausgefiltert wird nur, was WIRKLICH sichtbar ist (Seite 1 des
        // Rasters). Nachschub gibt es genug: die Rohansicht liefert bis zu 50
        // Kandidaten, angezeigt werden 8.
        var imRaster = Object.create(null);
        document.querySelectorAll('#filter-results a[href*="/products/"]').forEach(function (a) {
          var h = handleAus(a);
          if (h) imRaster[h] = true;
        });

        items = items.filter(function (item) {
          var h = handleAus(item.querySelector('a[href*="/products/"]'));
          return !h || !imRaster[h];
        });
        if (items.length < MIN_TREFFER) return;

        // Absteigend nach Prioritaet; bei Gleichstand bleibt die Reihenfolge,
        // die Shopify geliefert hat (Bestseller).
        items.sort(function (a, b) {
          var pa = parseFloat(a.getAttribute('data-prio')) || 0;
          var pb = parseFloat(b.getAttribute('data-prio')) || 0;
          if (pb !== pa) return pb - pa;
          return (parseInt(a.getAttribute('data-pos'), 10) || 0) -
                 (parseInt(b.getAttribute('data-pos'), 10) || 0);
        });

        // Bewusst ueber innerHTML und NICHT ueber importNode: die Karten
        // enthalten Custom Elements (<product-card>, <product-form>). Knoten
        // aus einem DOMParser-Dokument haengen an einer fremden Registry und
        // werden beim Uebernehmen nicht zuverlaessig initialisiert — dann
        // fehlt am Ende der Warenkorb-Button. Als HTML-String im echten
        // Dokument geparst, greift die Registry normal.
        var rail = el.querySelector('[data-zr-hm-rail]');
        rail.innerHTML = items
          .slice(0, MAX_KARTEN)
          .map(function (item) { return item.outerHTML; })
          .join('');

        var zaehler = el.querySelector('[data-zr-hm-count]');
        if (zaehler) zaehler.textContent = String(treffer);

        el.hidden = false;

        // Die Karten kommen mit data-src/data-srcset; befuellt werden die
        // echten Attribute vom Lazy-Loader des Themes, und der kennt nur, was
        // beim Laden der Seite schon im DOM stand. Ohne diesen Aufruf bleiben
        // die Bilder leer (nur das SVG-Platzhalterbild). Dieselbe Stelle rufen
        // Warenkorb-Drawer, Vergleich und Paginierung nach dem Nachladen auf.
        if (typeof window.initLazyImages === 'function') {
          window.initLazyImages();
        }
      })
      .catch(function () {
        /* Komfort-Element. Faellt es aus, bleibt das Raster unberuehrt. */
      });
  }

  function start() {
    document.querySelectorAll('[data-zr-hausmarken]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
